import React from 'react';

import styles from './AdditionalInfoOrder.module.scss';

const AdditionalInfoOrder = ({isBorderBottom, comment, present_at_home, present_at_home_desc}) => {
    return (
        <div className={`${styles.additionalInfoOrder} ${isBorderBottom ? styles.isBorder : ''}`}>
            {
                comment &&
                <div className={styles.additionalInfoOrder_block}>
                    <p>Додаткові коментарі</p>
                    <p>{comment}</p>
                </div>
            }

            <div className={styles.additionalInfoOrder_block}>
                <p>Як потрапити у дім?</p>
                {
                    present_at_home_desc ?
                        <p>{`${present_at_home}, ${present_at_home_desc}`}</p> :
                        <p>{present_at_home}</p>
                }
            </div>
        </div>
    );
};

export default AdditionalInfoOrder;
